import React from 'react';

const TextInput = (props) =>{

    let required = (props.required)? "required": null;

    let handleChange = (e) => {
        let obj = {};
        let fieldValue = e.target.value.trim();
        let isValid = (e.target.value.trim() !== '')? true : false;
        if (props.onChange && isValid) {
            obj[e.target.name] = fieldValue;
            props.onChange(obj);
        }
    }
    return (
        <div className="form-group">
          <label>{props.name}</label>
          <input type={props.type} name={props.shorName} className="form-control" placeholder={props.placeholder || ''} required={required} onChange={handleChange}/>
          <span id="helpBlock" className="help-block">{props.helpertext || ''}</span>
        </div>
    )
};

export default TextInput;


// WEBPACK FOOTER //
// ./src/components/elements/TextInput.js